const resource = {
    resource_identifier_in_use: 'API識別子 {{indicator}} はすでに使用されています',
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
